import { useContext, useState } from 'react';
import { Alert, Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { BeContext } from '../BeContext';
import { exportJval, publishTsExtract } from '../../data';
import { StatusContext } from '../StatusContext';

function ThreatStopPage() {
    const beContext = useContext(BeContext);
    const statusContext = useContext(StatusContext);

    const [fileName, setFileName] = useState('');
    const [jvalOutput, setJvalOutput] = useState('');
    const [isExportingJval, setIsExportingJval] = useState(false);
    const [isPublishingExtract, setIsPublishingExtract] = useState(false);
    const [error, setError] = useState<string | null>(null);

    async function handleExportJval() {
        setError(null);
        setIsExportingJval(true);
        try {
            const fn = await exportJval(fileName);
            setJvalOutput(fn);
            statusContext.postInfo(`Exported ThreatStop JSON to ${fn}`);
        } catch (e: any) {
            const msg = e?.message || String(e);
            setError(msg);
            statusContext.postError(`ThreatStop export failed: ${msg}`);
        } finally {
            setIsExportingJval(false);
        }
    }

    async function handlePublishTsExtract() {
        setError(null);
        setIsPublishingExtract(true);
        try {
            await publishTsExtract();
            statusContext.postInfo('Published TS extract');
        } catch (e: any) {
            const msg = e?.message || String(e);
            setError(msg);
            statusContext.postError(`TS extract publish failed: ${msg}`);
        } finally {
            setIsPublishingExtract(false);
        }
    }

    return (
        <Container fluid className="py-4 px-3">
            <Row>
                <Col md={10} lg={8}>
                    <Card border="primary">
                        <Card.Header as="h5">ThreatStop</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                This publishes fingerprints in the working set to a
                                Threatstop format JSON file. This contains a flattened set of
                                all DNS related matches for all fingerprints in the working set.
                            </Card.Text>

                            <Form.Group className="mb-3" controlId="threatstopFileName">
                                <Form.Label>Filename</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Filename"
                                    value={fileName}
                                    onChange={(e) => setFileName(e.target.value)}
                                />
                            </Form.Group>

                            <div className="d-flex gap-3 mb-3">
                                <Button variant="primary" onClick={handleExportJval} disabled={isExportingJval || isPublishingExtract}>
                                    {isExportingJval ? 'Exporting...' : `Export ${beContext.count()} fingerprints`}
                                </Button>
                            </div>

                            {jvalOutput ? (
                                <div className="mb-2">Wrote {beContext.count()} fingerprints to <span className="font-monospace">{jvalOutput}</span></div>
                            ) : null}

                            <Card.Text>
                                This creates the TS extract sample in the working set (any
                                existing working set is replaced). The sample is created
                                by sampling from the working curl probes then adding a group of
                                fingerprints that always should be there (identified by a tag).

                                This is then pushed to the threatstop sharing S3 bucket.
                            </Card.Text>

                            <Form.Group className="mb-3" controlId="threatstopExtractFileName">
                                <Form.Label>Filename</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Filename"
                                    value={fileName}
                                    onChange={(e) => setFileName(e.target.value)}
                                />
                            </Form.Group>

                            <div className="d-flex gap-3 mb-3">
                                <Button variant="primary" onClick={handlePublishTsExtract} disabled={isExportingJval || isPublishingExtract}>
                                    {isPublishingExtract ? 'Publishing...' : 'Publish TS extract'}
                                </Button>
                            </div>

                            {error ? <Alert variant="danger" className="mb-0">{error}</Alert> : null}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ThreatStopPage;
